import { getRandomInt } from "./MathUtils";
import { selectLabels } from "../constants/appConstants";
import {
  getDefaultMapPriorityKeys,
  getPriorityOrder,
  sortWithPrioritiesFirst,
  sortColumnsWithPrioritiesFirst,
} from "./priorityConfig";

// Re-export for backward compatibility
export { sortWithPrioritiesFirst, sortColumnsWithPrioritiesFirst };

/**
 * Get default priorities for maps (absolute numbers)
 * Returns the 2 main absolute priorities as objects with label/value
 */
export function getMapDefaultPriorities() {
  return getDefaultMapPriorityKeys().map((value) => ({
    label: selectLabels[value] ?? value,
    value,
  }));
}

/**
 * Legacy column toggle function
 */
export function removeOrAddColumn(data, columnName) {
  const columnRemoved = data.some((row) => row[0].startsWith(columnName));
  if (columnRemoved) {
    return data.filter((row) => !row[0].startsWith(columnName));
  } else {
    const index = data.findIndex((row) => row[0] === "Location");
    if (index !== -1) {
      const newRows = Array.from({ length: 9 }, (_, i) => [
        `${columnName}_${i + 1}`,
        `${i + 1}`,
        getRandomInt(30, 60),
        getRandomInt(-50, 50),
      ]);
      return [
        ...data.slice(0, index + 1),
        ...newRows,
        ...data.slice(index + 1),
      ];
    } else {
      console.error("Location row not found in data.");
      return data;
    }
  }
}

// Legacy export
export const priorityUnmetNeeds = getPriorityOrder(false);

/**
 * Filter and sort options for dropdowns - puts priorities at top
 * SIMPLIFIED: No isDemo parameter needed - shows all priorities for everyone
 * 
 * @param {string[]} array - All available options
 * @param {Object[]} selectedUnmet - Currently selected items [{value, label}]
 * @returns {string[]} - Sorted options array
 */
export function filterOutLabels(array, selectedUnmet, preferPercent = false) {
  return sortWithPrioritiesFirst(array, selectedUnmet, preferPercent);
}

/**
 * Filter and sort columns for table multi-select - puts priorities at top
 * SIMPLIFIED: No isDemo parameter needed - shows all priorities for everyone
 * 
 * @param {Object[]} array - All available columns [{id, ...}]
 * @param {Object[]} selectedUnmet - Currently selected items [{value, label}]
 * @returns {Object[]} - Sorted columns array
 */
export function filterOutLabelsTable(
  array,
  selectedUnmet,
  preferPercent = false,
) {
  return sortColumnsWithPrioritiesFirst(array, selectedUnmet, preferPercent);
}
